// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { userListUsersTableStyles } from "@conklin/Overrides/Widgets/UserList/UserListUsersTable";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

userListUsersTableStyles.noResultsContainer = {
    ...mergeWithCss(dataTableStyles.noResultsContainer, {
        css: css`
            padding-top: 16px;
            margin-bottom: 48px;
        `,
    }),
};

userListUsersTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

userListUsersTableStyles.wrapper = {
    css: css`
        margin-bottom: 48px;
    `,
};

userListUsersTableStyles.dateText = userListUsersTableStyles.statusText = {
    variant: "h6",
    weight: fontConfig.weight.regular,
    css: css`
        margin: 0;
    `,
};

userListUsersTableStyles.container = {
    css: css`
        overflow-x: auto;
        margin-top: 16px;
    `,
};
